import { css } from 'linaria';
"s1alsd5h";

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Theme/sanitizeCss.linaria.css");